import { render, staticRenderFns } from "./EventiList.vue?vue&type=template&id=b58fe6bc&scoped=true&"
import script from "./EventiList.vue?vue&type=script&lang=ts&"
export * from "./EventiList.vue?vue&type=script&lang=ts&"
import style0 from "./EventiList.vue?vue&type=style&index=0&id=b58fe6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58fe6bc",
  null
  
)

export default component.exports